export abstract class UnitSystem {
  static readonly METRICS = 'M';
  static readonly ENGLISH = 'EN';
  static readonly MetricMeasurementUnit = 'mm';
  static readonly EnglishMeasurementUnit = 'in';
  static readonly CELSIUS = '°C';
  static readonly FAHRENHEIT = '°F';
  static decimalCount: number;

  static getTypeByUnit(unit: string) {
    if (unit === UnitSystem.MetricMeasurementUnit) {
        return UnitSystem.METRICS;
    }
    return UnitSystem.ENGLISH;
  }

  static convertToInches (value: number) {
    return +(value * 0.03937007874).toFixed(3);
  }

  static convertToMm (value: number): number {
    return +(value / 0.03937007874).toFixed(2);
  }

  static convertDataToEnglish (data, unit) {
    let convertDistance;
    if (unit === 0) {
      convertDistance = this.convertToMm;
      this.decimalCount = 2;
    } else {
      convertDistance = this.convertToInches;
      this.decimalCount = 3;
    }
    if (data.angle) {
      data.gap = convertDistance(+data.gap).toFixed(this.decimalCount);
      data.glandDepth = convertDistance(+data.glandDepth).toFixed(this.decimalCount);
      data.glandDepthTol = convertDistance(+data.glandDepthTol).toFixed(this.decimalCount) || data.glandDepthTol;
      data.glandOpening = convertDistance(+data.glandOpening).toFixed(this.decimalCount);
      data.glandOpeningTol = convertDistance(+data.glandOpeningTol).toFixed(this.decimalCount) || data.glandOpeningTol;
      data.grooveDiameter = convertDistance(+data.grooveDiameter).toFixed(this.decimalCount);
      data.grooveDiameterTol = convertDistance(+data.grooveDiameterTol).toFixed(this.decimalCount) || data.grooveDiameterTol;
      data.topRadius = convertDistance(+data.topRadius).toFixed(this.decimalCount);
      data.bottomRadius = convertDistance(+data.bottomRadius).toFixed(this.decimalCount);
    } else {
      data.oringSizeID = convertDistance(+data.oringSizeID).toFixed(this.decimalCount);
      data.oringSizeIDTol = convertDistance(+data.oringSizeIDTol).toFixed(this.decimalCount);
      data.oringSizeCs = convertDistance(+data.oringSizeCs).toFixed(this.decimalCount);
      data.oringSizeCsTol = convertDistance(+data.oringSizeCsTol).toFixed(this.decimalCount);
    }
  }
}



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/details/UnitSystem.ts